import { render, staticRenderFns } from "./HeaderBasketDropdown.vue?vue&type=template&id=65e648a7"
import script from "./HeaderBasketDropdown.vue?vue&type=script&lang=js"
export * from "./HeaderBasketDropdown.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports